module.exports = __webpack_public_path__ + "assets/img/banner1.682aa226.png";